import { Box, Button, Typography } from '@mui/material'
import { getMediaState, setIsPerkins } from '@/features/media/slice'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'

export const SwitchThemeSection = () => {
  const { isPerkins } = useAppSelector(getMediaState)
  const dispatch = useAppDispatch()

  return (
    <Box>
      <Typography variant="subtitle2" gutterBottom>
        Theme
      </Typography>
      <Button
        variant="outlined"
        size="small"
        onClick={() => dispatch(setIsPerkins(!isPerkins))}
      >
        Switch to {isPerkins ? 'Caterpillar' : 'Perkins'}
      </Button>
    </Box>
  )
}
